export default __webpack_public_path__ + "vendor/ckeditor/plugins/a11yhelp/dialogs/lang/zh.js";